import React, { useEffect, useState } from "react";
import "../styles/gallery.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ImageGallery from "../components/ImageGallery";

const Gallery: React.FC = () => {
  const [imagePaths, setImagePaths] = useState<string[]>([]);

  useEffect(() => {
    fetch("/galleryImages.json")
      .then((res) => res.json())
      .then((files: string[]) => setImagePaths(files.map(name => `/imageGallery/${name}`)));
  }, []);

  return (
    <>
      <header
        className="hero"
        style={{
          backgroundImage: "url(/images/header.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "50vh",
          minHeight: 0,
          overflow: "hidden"
        }}
      >
        <Navbar />
        <div className="hero-content">
          <div className="hero-text">
            <h1>Galeri</h1>
          </div>
        </div>
      </header>
      <div style={{ padding: '2rem 0', background: '#f8f8f8' }}>
        {/* 6 sütun x 5 satır = 30 görsel */}
        <ImageGallery images={imagePaths} pageSize={30} />
      </div>
      {/* Galeri içeriği buraya eklenebilir */}
      <Footer />
    </>
  );
};

export default Gallery; 